/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */
"use strict";
(function(global) {
    class SimpleOrderedTable {
        constructor(config) {
            this.init(config);
        }

        init(config) {
            this.config = config;
            this.drawTable(this.prepareData());
        }

        prepareData() {
            return this.config["data"];
        }

        drawTable(data) {
            const id = this.config["table-id"];
            const tableSelector = '#' + id;

            let ordinal = 1;
            const me = this;
            let rowHtml;
            let value;
            $(tableSelector).html('');
            data.rows.forEach(function (row) {
                rowHtml = '<tr data-id="' + row.id + '"><td>' + (ordinal++) + '</td>';
                me.config.fields.forEach(function (fieldName) {
                    value = row[fieldName];
                    if (Array.isArray(value)) {
                        value = value.join("\n");
                    }
                    rowHtml += '<td>' + value + '</td>';
                });
                rowHtml += '<td><button class="edit">Edytuj</button></td>';
                $('#' + id).append(rowHtml);
            });

            rowHtml = '<tr><td>' + (ordinal++) + '</td>';
            me.config.fields.forEach(function () {
                rowHtml += '<td></td>';
            });
            rowHtml += '<td><button class="add">Dodaj</button></td>';
            $(tableSelector).append(rowHtml);
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Grid = global.NS.Grid || {};
    global.NS.Grid.SimpleOrderedTable = SimpleOrderedTable || {};

})(window);
